// src/apiService.js
import axios from 'axios';
import API_BASE_URL from './apiConfig';

// Set up axios instance with default settings
const api: any = new Proxy({}, {
  get(target, prop) {
    const headers: any = {
      'Content-Type': 'application/json',
    };
    const token = localStorage.getItem('token');
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    // Create a new Axios instance with the updated headers
    const axiosInstance: any = axios.create({
      baseURL: API_BASE_URL,
      headers: headers,
    });

    // Return the method from the Axios instance (e.g., post, get, etc.)
    return axiosInstance[prop].bind(axiosInstance);
  }
});

const buildQueryString = (params: any) => {
  let queryParams = '?offset=' + params.offset + '&limit=' + params.limit;
  if (params.sort) {
      if (params.sort.length > 0) {
          let sortString = '';
          params.sort.forEach( (value:any) => {
              if (sortString.length > 0) {
                  sortString += ',';
              }
              sortString += value.field + '|' + value.order;
          });
          queryParams += '&sortby=' + sortString;
      }
  }
  if (params.filters) {
      let filterString = '';
      params.filters.forEach( (filter:any) => {
          let fieldString = '';
          filter.forEach( (field: any) => {
              if (fieldString.length > 0) {
                  fieldString += ',';
              }
              fieldString += field.property + '|' + field.operator + '|' + field.value;
          });
          if (fieldString.length > 0) {
              fieldString = '(' + fieldString + ')';
          }
          if (filterString.length > 0) {
              filterString += ',';
          }
          filterString += fieldString;
      });
      queryParams += '&filter=' + encodeURIComponent(filterString);
  }
  if (params.expand) {
      queryParams += '&expand=' + params.expand;
  }
  return queryParams;
}

// Function to handle lead creation
export const createLead = async (leadData: any) => {
  try {
    const response = await api.post('/leads', leadData);
    return response.data;
  } catch (error) {
    console.error('Error creating lead:', error);
    throw error;
  }
};

export const getLeads = async (value: any = {}) => {
  try {
    const query = buildQueryString(value)
    const response = await api.get(`/leads/?${query}`);
    return response.data;
  } catch (error) {
    console.error('Error creating lead:', error);
    throw error;
  }
};

export const updateLead = async (leadData: any) => {
  try {
    const response = await api.put(`/leads/${leadData.id}`, leadData);
    return response.data;
  } catch (error) {
    console.error('Error updating lead:', error);
    throw error;
  }
};

export const deleteLead = async (leadData: any) => {
  try {
    const response = await api.delete(`/leads/${leadData.id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting lead:', error);
    throw error;
  }
};